import Booking from '@/models/Booking'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    bookingDetails: null,
  },

  mutations: {
    setBookingList(state, bookings) {
      each(bookings, (booking) => {
        const exist = find(state.list, { id: booking.id })
        if (!exist) {
          state.list.push(new Booking(booking))
        }
      })
    },

    clearBookingList(state) {
      state.list = []
    },

    setBookingListMeta(state, meta) {
      state.listMeta = meta
    },

    setBookingDetails(state, booking) {
      if (booking instanceof Booking) {
        state.bookingDetails = booking
      } else {
        state.bookingDetails = new Booking(booking)
      }
    },

    clearBookingDetails(state) {
      state.bookingDetails = null
    },

    setSelectedCategoryAvatar(state, avatar) {
      if (avatar instanceof Avatar) {
        state.categoryDetails.avatar = avatar
      } else {
        state.categoryDetails.avatar = new Avatar(avatar)
      }
    },

    categoryAvatarRemoved(state) {
      state.userDetails.avatar = null
    },
  },

  actions: {
    async getBookings({ commit }, params) {
      const query = Booking.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.sort_direction) {
        query.params({ sort_direction: params.sort_direction })
      }

      let loadPrams = {
        limit: 1,
        sort_direction: params.sort_direction,
        sort_by: params.sort_by,
      }

      if (params.limit) {
        loadPrams.limit = params.limit
      }

      const res = await query.params(loadPrams).get()

      commit('clearBookingList')
      commit('setBookingList', res.data)
      commit('setBookingListMeta', res.meta)
    },

    async getBookingDetails({ commit }, id) {
      const { data } = await Api.get(`admin/bookings/${id}`)
      commit('setBookingDetails', data.data)
    },

    async changeAvatar({ commit }, formData) {
      const { data } = await Api.post(
        `users/${formData.get('user_id')}/avatar`,
        formData
      )
      commit('setSelectedCategoryAvatar', data.data)
    },

    async updateBooking({ commit }, form) {
      const { data } = await Api.put(`admin/bookings/${form.id}`, form)
      commit('setCategoryDetails', data.data)
    },

    async createBooking({ commit }, form) {
      let formData = new FormData()

      if (form.name) {
        formData.append('name', form.name)
      }

      if (form.name) {
        formData.append('brand', form.brand)
      }

      if (form.description) {
        formData.append('description', form.description)
      }

      if (form.price_per_day) {
        formData.append('price_per_day', form.price_per_day)
      }

      if (form.parent_category_id) {
        formData.append('parent_category_id', form.parent_category_id)
      }

      if (form.sub_category_id) {
        formData.append('sub_category_id', form.sub_category_id)
      }

      if (form.condition_id) {
        formData.append('condition_id', form.condition_id)
      }

      if (form.delivery_method_id) {
        formData.append('delivery_method_ids[]', form.delivery_method_id)
      }

      if (form.owner_id) {
        formData.append('owner_id', form.owner_id)
      }

      if (form.line) {
        formData.append('line', form.line)
      }

      if (form.city) {
        formData.append('city', form.city)
      }

      if (form.state) {
        formData.append('state', form.state)
      }

      if (form.postal_code) {
        formData.append('postal_code', form.postal_code)
      }

      if (form.country) {
        formData.append('country', form.country)
      }

      if (form.latitude) {
        formData.append('latitude', form.latitude)
      }

      if (form.longitude) {
        formData.append('longitude', form.longitude)
      }

      if (form.images) {
        form.images.forEach((image) => {
          formData.append('images[]', image)
        })
      }

      const { data } = await Api.post(`admin/bookings`, formData)
      commit('setCategoryDetails', data.data)
    },

    async exportToExcel() {
      const file = await Api.get('/users/export', { responseType: 'blob' })
      return file
    },
  },
}
